import de from '@translations/de/editBrand.json';
import en from '@translations/en/editBrand.json';
import pl from '@translations/pl/editBrand.json';
import sl from '@translations/sl/editBrand.json';
import uk from '@translations/uk/editBrand.json';
import bg from '@translations/bg/editBrand.json';
import cz from '@translations/cz/editBrand.json';
import fr from '@translations/fr/editBrand.json';
import gr from '@translations/gr/editBrand.json';
import it from '@translations/it/editBrand.json';
import pr from '@translations/pr/editBrand.json';
import ru from '@translations/ru/editBrand.json';
import sk from '@translations/sk/editBrand.json';
import sp from '@translations/sp/editBrand.json';
import tr from '@translations/tr/editBrand.json';
import hu from '@translations/hu/editBrand.json';
import { ITranslations } from '@/types/common';
import { EditBrandTransFields } from './types';

export const editBrandTranslations: ITranslations<EditBrandTransFields> = {
  name: 'editBrand',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
